import { render, staticRenderFns } from "./NoMarketplaceComponent.vue?vue&type=template&id=8789b516&"
import script from "./NoMarketplaceComponent.vue?vue&type=script&lang=js&"
export * from "./NoMarketplaceComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports